import BaseFile from '@/modules/common/models/file/base-file.ts';
import UploadFile from '@/modules/common/models/file/upload-file.ts';
import axios from 'axios';
import type { UpdatedEditorFile } from '@/modules/document/stores/file-editor.ts';

export default class UpdatedFile extends UploadFile {
  timestamp: number;
  documentId: number;
  url: string;

  private uploadPromise?: Promise<void>;

  constructor(file: UpdatedEditorFile) {
    super(file.id, file.name);
    this.timestamp = file.timestamp;
    this.documentId = file.documentId;
    this.url = file.updatedUrl;
  }

  async upload() {
    this.uploadPromise ||= this.setBase64();
    await this.uploadPromise;
  }

  private async setBase64() {
    const { data: blob } = await axios.get(this.url, { responseType: 'blob' });
    this.size = blob.size;
    this.base64 = await BaseFile.toBase64(blob);
  }
}
